import React, { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'

type Props = { content: React.ReactNode; children: React.ReactNode; placement?: 'top'|'bottom'|'left'|'right' }
export function Tooltip({ content, children, placement = 'top' }: Props) {
  const [open, setOpen] = useState(false)
  const ref = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const onEsc = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('keydown', onEsc)
    return () => document.removeEventListener('keydown', onEsc)
  }, [])
  const pos = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-1',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-1',
    left: 'right-full top-1/2 -translate-y-1/2 mr-1',
    right: 'left-full top-1/2 -translate-y-1/2 ml-1',
  }[placement]
  return (
    <div ref={ref} className="relative inline-block" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      {children}
      {open && (
        <div role="tooltip" className={clsx('absolute z-[100] whitespace-nowrap rounded bg-black/80 text-white text-xs px-2 py-1 pointer-events-none', pos)}>
          {content}
        </div>
      )}
    </div>
  )
}
